import React, { useEffect, useMemo, useState } from "react"
import {
  Table,
  Row,
  Col,
  Card,
  CardBody,
  Modal,
  Form,
  Label,
} from "reactstrap"
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table"
import { useNavigate } from "react-router-dom"
import NewPagination from "components/Common/Newpagination"
import AccessDeniedPopup from "routes/AccessDeniedPopup"
import Select from "react-select"
import Swal from "sweetalert2"
import Loader from "pages/Separate/Loader"
import calendarImage from "../../../../../assets/images/leavemanage.jpg"
import configure from "configure"
import axios from "axios"
import { useSelector } from "react-redux"

function TableContainer({ columns, data, setAddCalendar, setAccessDenied }) {
  const [fixedContent, setFixedContent] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setFixedContent(true)
      } else {
        setFixedContent(false)
      }
    }
    document.addEventListener("scroll", handleScroll)
    return () => document.removeEventListener("scroll", handleScroll)
  }, [])

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    pageCount,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        sortBy: [
          {
            id: "id",
            desc: true,
          },
        ],
      },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  )

  const { pageIndex, pageSize, globalFilter } = state
  useEffect(() => setPageSize(50), [])

  return (
    <div>
      <div
        className={`flex-column fixed-buttons ${fixedContent ? "d-flex" : "d-none"
          }`}
      >
        <button onClick={() => navigate(-1)} className="btn btn-red fix-btn">
          <i className="dripicons-cross me-2 icon-center"></i>
          <span>Cancel</span>
        </button>
      </div>
      <Row className="mb-2">
        <Col>
          <select
            className="form-select"
            style={{ width: "100px" }}
            value={pageSize}
            onChange={e => setPageSize(e.target.value)}
          >
            {[10, 20, 30, 40, 50].map(pageSize => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </select>
        </Col>
        <Col md={8} className="d-flex justify-content-end gap-2">
          <div className="me-4">
            <div className="search-box my-xxl-0 d-inline-block">
              <div className="position-relative">
                <label htmlFor="search-bar-0" className="search-label">
                  <span id="search-bar-0-label" className="sr-only">
                    Search this table
                  </span>
                  <input
                    onChange={e => setGlobalFilter(e.target.value)}
                    id="search-bar-0"
                    type="text"
                    className="form-control rounded h-100"
                    placeholder={` Search...`}
                    value={globalFilter || ""}
                  />
                </label>
                <i className="bx bx-search-alt search-icon"></i>
              </div>
            </div>
          </div>
          <div>
            <button
              onClick={() => navigate(-1)}
              className="btn btn-red btn-label"
            >
              <i className="dripicons-cross icon-center me-2 label-icon"></i>
              CANCEL
            </button>
          </div>
        </Col>
      </Row>
      <Table className="table table-bordered mt-4" {...getTableProps()}>
        <thead
          className={`${fixedContent && page.length >= 10 ? "fixed-oe-setting-header" : ""
            }`}
        >
          {headerGroups.map((headerGroup, i) => (
            <tr key={i} {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column, index) => (
                <th
                  key={index}
                  className={`${column.className} customShortIcon`}
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                >
                  {column.render("Header")}
                  {column.isInfoIcon ? (
                    <i
                      title="info"
                      className="bx bx-info-circle ms-1 info-icon"
                    ></i>
                  ) : null}
                  {column.isShortIcon && (
                    <span
                      onClick={() => column.getSortByToggleProps().onClick()}
                      className="ms-2 cursor-pointer"
                    >
                      <i
                        title="Ascending"
                        className={`bi bi-arrow-up info-icon ${column.isSorted && !column.isSortedDesc
                          ? "text-dark"
                          : ""
                          }`}
                      ></i>
                      <i
                        title="Descending"
                        className={`bi bi-arrow-down info-icon ${column.isSorted && column.isSortedDesc
                          ? "text-dark"
                          : ""
                          }`}
                      ></i>
                    </span>
                  )}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row)
            return (
              <tr className="row-hover" {...row.getRowProps()} key={i}>
                {row.cells.map((cell, index) => (
                  <td
                    className={cell.column.className}
                    key={index}
                    {...cell.getCellProps()}
                  >
                    {cell.render("Cell")}
                  </td>
                ))}
              </tr>
            )
          })}
        </tbody>
      </Table>
      <Row className="justify-content-md-end justify-content-center align-items-center">
        <NewPagination
          gotoPage={gotoPage}
          canPreviousPag={canPreviousPage}
          canNextPage={canNextPage}
          pageIndex={pageIndex}
          pageOptions={pageOptions}
          pageSize={pageSize}
          page={page}
          data={data}
        />
      </Row>
    </div>
  )
}

const CalendarAccessTab = () => {
  const [editCalendar, setEditCalendar] = useState(false)
  const [addCalendar, setAddCalendar] = useState(false)
  const [data, setDatas] = useState([])
  const [modal_Access, setAccessDenied] = useState(false)
  const [editData, setEditData] = useState(null)
  const [selectedStaff, setSelectedStaff] = useState(null)
  const [selectedAssignees, setSelectedAssignees] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  // State for StaffOption
  const [staffOptions, setStaffOptions] = useState([])
  const generalData = useSelector(state => state?.GeneralData?.generalData)
  const assigneeOptions = generalData?.staff;

  const fetchData = async () => {
    try {
      setIsLoading(true)
      const response = await axios.get(`${configure.nodeApi}/calenderAccess`)
      setDatas(response.data)

      // Extract unique staff members for StaffOption
      const uniqueStaff = [
        ...new Map(
          response.data.map(item => [
            item.staff.id,
            { value: item.staff.id, label: item.staff.alias_name },
          ])
        ).values(),
      ]
      setStaffOptions(uniqueStaff)

    } catch (error) {
      console.error("Error fetching calendar access:", error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        isShortIcon: true,
        className: "text-center mt_id",
        Cell: ({ row }) => row.index + 1,
      },
      {
        Header: "Staff",
        accessor: "staff.alias_name",
        isShortIcon: true,
        className: "mt_staff",
        Cell: ({ row }) => (
          <div className="text-start">{row.original.staff.alias_name}</div>
        ),
      },
      {
        Header: "Assignees",
        accessor: "assignees",
        isShortIcon: true,
        className: "mt_assignees",
        Cell: ({ row }) => (
          <div className="text-start">
            {row.original.assignees.map(a => a.alias_name).join(", ")}
          </div>
        ),
      },
      {
        Header: "Action",
        accessor: "action",
        className: "text-center oe-action",
        Cell: ({ row }) => {
          return (
            <div>
              <button
                onClick={() => {
                  setEditData(row.original)
                  setSelectedStaff({
                    value: row.original.staff.id,
                    label: row.original.staff.alias_name,
                  })
                  setSelectedAssignees(
                    row.original.assignees.map(a => ({
                      value: a.id,
                      label: a.alias_name,
                    }))
                  )
                  setEditCalendar(true)
                }}
                className="btn action-btn btn-sm btn-outline-secondary"
              >
                <i className="fas fa-pencil-alt"></i>
              </button>
            </div>
          )
        }
      },
    ],
    []
  )

  const handleEditSubmit = async e => {
    e.preventDefault()
    if (editData && selectedStaff && selectedAssignees.length > 0) {
      setIsLoading(true)
      const requestBody = {
        staff: selectedStaff.value,
        assignee: selectedAssignees.map(a => a.value).join(","),
      }
      try {
        const updateData = await axios.post(
          `${configure.nodeApi}/calenderAccess`,
          requestBody
        )

        const res = updateData.data
        if (res.status && res.data) {
          setDatas(res.data)
          const uniqueStaff = [
            ...new Map(
              res.data.map(item => [
                item.staff.id,
                { value: item.staff.id, label: item.staff.alias_name },
              ])
            ).values(),
          ]
          setStaffOptions(uniqueStaff)

          setEditCalendar(false)
          setSelectedStaff(null)
          setSelectedAssignees([])
          setEditData(null)
          Swal.fire(
            "Success!",
            "Calendar access updated successfully.",
            "success"
          )
        } else {
          Swal.fire({
            icon: "error",
            title: "Update Failed",
            text: res.message || "Failed to update calendar access.",
          })
        }
        setIsLoading(false)
      } catch (error) {
        setIsLoading(false)
        console.error("Error updating calendar access:", error)
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "An error occurred while updating calendar access.",
        })
      }
    } else {
      setIsLoading(false)
      Swal.fire({
        icon: "warning",
        title: "Missing Data",
        text: "Please select a staff and at least one assignee.",
      })
    }
  }

  return (
    <>
      {isLoading && <Loader />}
      <div>
        <Row className="ms-0 pe-0">
          <Col lg={12} className="p-0">
            <Card>
              <CardBody>
                <TableContainer
                  columns={columns}
                  data={data}
                  setAddCalendar={setAddCalendar}
                  setAccessDenied={setAccessDenied}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>


      {/* Edit Calendar Access Modal */}
      <Modal isOpen={editCalendar} centered size="lg">
        <div className="modal-header">
          <h5 className="modal-title mt-0">Edit Calendar Access</h5>
          <button
            type="button"
            onClick={() => {
              setEditCalendar(false)
              setSelectedStaff(null)
              setSelectedAssignees([])
              setEditData(null)
            }}
            className="btn-modal-close"
          >
            <span className="btn-modal-span">×</span>
          </button>
        </div>
        <div className="modal-body">
          <Row>
            <Col md={4} className="text-center">
              <img
                src={calendarImage}
                alt="Calendar Access"
                className="img-fluid rounded"
                style={{ maxHeight: "250px", objectFit: "contain" }}
              />
            </Col>
            <Col md={8}>
              <Form>
                <div className="mb-3">
                  <Label htmlFor="formrow-staff">
                    Select Staff <span className="text-danger">*</span>
                  </Label>
                  <Select
                    placeholder="Select Staff"
                    className="basic-multi-select"
                    classNamePrefix="select"
                    isDisabled
                    options={staffOptions}
                    value={selectedStaff}
                    onChange={setSelectedStaff}
                  />
                </div>
                <div className="mb-3">
                  <Label htmlFor="formrow-assignees">
                    Select Assignees <span className="text-danger">*</span>
                  </Label>
                  <Select
                    placeholder="Select Assignees"
                    className="basic-multi-select"
                    classNamePrefix="select"
                    isMulti
                    options={assigneeOptions }
                    value={selectedAssignees}
                    onChange={setSelectedAssignees}
                    closeMenuOnSelect={false}
                  />
                </div>
                <div className="border-bottom my-3"></div>
                <div className="text-end">
                  <button
                    type="submit"
                    className="btn btn-save btn-label"
                    onClick={handleEditSubmit}
                  >
                    <i className="fas fa-save me-2 label-icon"></i>
                    Submit
                  </button>
                  <button
                    onClick={() => {
                      setEditCalendar(false)
                      setSelectedStaff(null)
                      setSelectedAssignees([])
                      setEditData(null)
                    }}
                    className="btn btn-red btn-label ms-3"
                  >
                    <i className="dripicons-cross icon-center me-2 label-icon"></i>
                    Cancel
                  </button>
                </div>
              </Form>
            </Col>
          </Row>
        </div>
      </Modal>

      {/* Access Denied Popup */}
      <AccessDeniedPopup
        modal_Access={modal_Access}
        setAccessDenied={setAccessDenied}
      />
    </>
  )
}

export default CalendarAccessTab